import { openExtUrl } from "./commanFunctions";
import { InnSpireChatShowConversation } from "../components/Chat";

export const runAction = (action, navigate) => {
  if (!action) return;
  switch (action.type) {
    case "navigate":
      navigate(`/?path=${action.path || ""}`);
      break;
    case "external":
      openExtUrl(action.url, "_blank");
      break;
    case "tel":
      window.location.href = `tel:${action.number}`;
      break;
    case "chatbot":
      InnSpireChatShowConversation({});
      break;
    default:
      break;
  }
};

export const hrefForAction = (action) => {
  if (!action) return null;
  if (action.type === "navigate") return `/?path=${action.path || ""}`;
  return null;
};
